import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_SITE = 'FETCH_SITE'
const FETCH_SITES = 'FETCH_SITES'
const FETCH_DOMAIN_CONFIG = 'FETCH_DOMAIN_CONFIG'
const CHECK_SLUG_AVAILABILITY = 'CHECK_SLUG_AVAILABILITY'

export const getSiteApi = apiCall(
  FETCH_SITE,
  ({ id }: { id: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${id}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getSitesApi = apiCall(FETCH_SITES, () => ({
  endpoint: getApiUrl(`/api/cms/v1/sites`),
  method: 'GET',
  headers: appApiHeaders(),
}))

export const getDomainConfigApi = apiCall(
  FETCH_DOMAIN_CONFIG,
  ({ id }: { id: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${id}/domain/config`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const checkSlugAvailabilityApi = apiCall(
  CHECK_SLUG_AVAILABILITY,
  ({ slug }: { slug: string }) => ({
    endpoint: getApiUrl(`/api/public/v1/sites/slug/${slug}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
